<div class="home-page">

    <div class="main">
        <div class="section-1">
            <p>Jak zacząć?</p>
            <img src="/assets/people-1.png" srcset="/assets/people-1.png, /assets/people-1@2x.png 2x" alt="WAGAS">
        </div>
        <div class="section-2">
            <ul>
                <li>
                    <span class="num">1</span>
                    <span class="text">
                        Aby wysłać dokumenty, wybierz opcję "Stwórz wysyłkę"
                    </span>
                </li>
                <li>
                    <span class="num">2</span>
                    <span class="text">
                        Możesz wybrać dokumenty z dowolnych marek, a nawet dołączyć własne
                    </span>
                </li>
                <li>
                    <span class="num">3</span>
                    <span class="text">
                        Aby przyspieszyć dostęp do aplikacji, wybierz w przeglądarce mobilnej opcję
                        <em>"Dodaj do ekranu głównego"</em>
                    </span>
                </li>
            </ul>
        </div>
    </div>

    <div class="button-wrapper">
        <button kendoButton class="big" [primary]="true" routerLink="/stworz-wysylke">
            <span class="item-icon material-icons send-white"></span>
            Stwórz wysyłkę
        </button>
    </div>

</div>